<script>
    import { user } from '../stores';
    import firebase from 'firebase/app';
    import { auth, firebaseConfig, functions } from '../firebase';
    import { getAvatarUrl } from '../discord';
    import Debug from './debug';
    
    // import { apiUrl, clientId, clientSecret } from '../discord';
        
    if ($user) {
        // TODO: why doesn't this automatically redirect to '/'?  Look into it, shouldn't need to set location...?
        window.history.replaceState({}, document.title, '/');
        window.location = '/';
    }

    // TODO: what happens if the user manually changes the address?  maybe don't react to this?
    // ^v used to be $: urlpath ...
    const urlpath = window.location.pathname;
    // TODO: maybe use an easier-to-understand way of getting everything after '/auth' in the URL
    // TODO: implement other features ever?
    const service = urlpath.split('/auth').slice(1).join('/auth').substr(1);
    // See: https://stackoverflow.com/a/901144/3403247
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    let previousAuthenticationState = null;

    // See: https://stackoverflow.com/questions/53992730/how-would-i-authorize-users-using-discord-oauth2-0-for-firebase-authentication-o
    // And: https://stackoverflow.com/questions/47415787/how-should-i-create-a-new-federated-identity-provider-for-firebase-authenticatio
    // And: https://stackoverflow.com/questions/39110455/signinwithcustomtoken-with-firebases-own-tokens
    // And: https://stackoverflow.com/questions/40048517/does-firebase-custom-authentication-require-that-you-manage-refresh-tokens-for-w

    // More in-depth: https://firebase.googleblog.com/2016/10/authenticate-your-firebase-users-with.html

    if (service === 'discord') {
        previousAuthenticationState = window.opener.getAuthenticationState();

        if (previousAuthenticationState === state) {
            console.log(`CALLING discordAuth with ${code}`);
            // Authenticate!
            functions.httpsCallable('discordAuth')({ code })
                .then(response => {  // TODO: type this
                    console.log('response');
                    console.log(response);

                    // See for auth persistence: https://firebase.google.com/docs/auth/web/auth-state-persistence

                    // Use a temporary Firebase app to sign in so that profile picture can be updated before the auth listener triggers
                    // See: https://firebase.googleblog.com/2016/10/authenticate-your-firebase-users-with.html
                    const tempApp = firebase.initializeApp(firebaseConfig, '_temp_');
                    // app.auth() is shorthand for firebase.auth(app), see: https://firebase.google.com/docs/reference/js/firebase.app.App#auth
                    // firebase.auth() returns the Auth for the default app, and we need the Auth for tempApp, see: https://firebase.google.com/docs/reference/js/firebase.auth.html
                    tempApp.auth().signInWithCustomToken(response.data.firebaseToken)
                        .then(userCredential => {
                            console.log('IN USER');
                            const user = userCredential.user;
                            console.log(user);
                            // TODO: write security rules
                            // See: https://firebase.google.com/docs/firestore/security/get-started
                            // Save the Discord API access token in the Cloud Firestore
                            // Also save the Discord userId
                            const tasks = [];
                            // const tasks = [tempApp.database().ref('/discordAccessToken/' + user.uid)
                            //      .set(discordAccessToken)];

                            // Update user displayname and photoURL if needed.
                            const DISCORD_UID_PREFIX = 'discord:';
                            const photoURL = response.data.avatar && getAvatarUrl(user.uid.substring(user.uid.indexOf(DISCORD_UID_PREFIX) + DISCORD_UID_PREFIX.length), response.data.avatar);
                            if (response.data.displayName !== user.displayName || photoURL !== user.photoURL) {
                                tasks.push(user.updateProfile({
                                    displayName: response.data.username,
                                    photoURL,
                                }));
                            }

                            // TODO: since read quota is larger than write
                            // quota, check if data has changed?  Might result
                            // in read+write though...  But data doesn't change
                            // that often I guess.
                            // Or just don't update it at _every_ sign-in
                            
                            const username = `${response.data.username}#${response.data.discriminator}`;
                            const userDocRef = tempApp.firestore().collection('users').doc(user.uid);
                            // Store username as displayName#discriminator so
                            // queries can be done on displayName without the
                            // discriminator
                            userDocRef.set({
                                displayName: response.data.username,
                                displayName_lowercase: response.data.username.toLowerCase(),
                                discriminator: response.data.discriminator,
                                username,
                                username_lowercase: username.toLowerCase(),
                                photoURL,
                                friendsListVisibility: 'friends',
                                lastActive: new Date(),
                            }, { merge: true })
                                .then(() => {
                                    console.log(`User written with ID: ${user.uid}`);

                                    // const promises = [];
                                    /*tasks.push(*/userDocRef.collection('privateData').doc('discordTokens').set({
                                        ...response.data.discordToken,
                                        expiration: new Date(response.data.discordToken.expiration),
                                    })
                                        .then(() => {
                                            console.log('Discord tokens written');

                                            // ! TODO: un-nest all these promises

                                            Promise.all(tasks).then(() => {
                                                Promise.all([
                                                    auth.signInWithCustomToken(response.data.firebaseToken),
                                                    tempApp.delete(),
                                                ]).then(() => {
                                                    window.close();
                                                });
                                            });
                                        })
                                        .catch(e => console.error(`Error adding private data: ${e}`));

                                })
                                .catch(e => console.error(`Error adding user: ${e}`));
                        });
                })
                .catch(e => {
                    console.log(e);
                });

            // const params = `client_id=${clientId}&client_secret=${clientSecret}&grant_type=authorization_code&code=${code}&redirect_uri=http%3A%2F%2Flocalhost%3A5000%2Fauth%2Fdiscord&response_type=code&scope=identify`;
            // console.log(params);
            // fetch(`${apiUrl}/oauth2/token`, {
            //     method: 'POST',
            //     body: params,
            //     headers: {
            //         'Content-Type': 'application/x-www-form-urlencoded',
            //     },
            // }).then(response => {
            //     console.log('RESPONSE');
            //     console.log(response);
            //     return response.json();
            // }).then(json => {
            //     console.log('JSON');
            //     console.log(json);
            //     resolve(json);
            // }).catch(e => {
            //     console.log(`ERROR: ${e}`);
            //     reject(e);
            // });
            
            // // TODO: move this into the authenticated store?  Maybe change to authentication and also store refresh/access token there?  And hydrate it from somewhere safe?  Like some safe storage or server?
            // const discordTokenURL = `https://discordapp.com/api/oauth2/token`;
            // // According to the Discord developers oauth2 page, content needs to be x-www-form-urlencoded
            // // See: https://stackoverflow.com/a/9713078/3403247
            // const params = `client_id=${clientId}&client_secret=${clientSecret}&grant_type=authorization_code&code=${authparams.code}&redirect_uri=http%3A%2F%2Flocalhost%3A5000%2Fauth%2Fdiscord&response_type=code&scope=identify`;
            
            // // TODO: fetch?
            // const xhr = new XMLHttpRequest();
            // // TODO: vs onreadystatechange?
            // xhr.onload = () => {
            //     // Might not need to check this since we're using onload
            //     if (xhr.readyState === XMLHttpRequest.DONE) {
            //         console.log('Done');
            //         console.log(xhr.status);
            //         console.log(xhr.response);
            //         console.log(xhr.response.scope);
            //         accessToken.set(xhr.response.access_token);
            //         // TODO: probably want to create a user here if they are not already registered with our app, then load from that user and not from Discord API anymore.  unless we _just_ want to use discord..?
            //         // See: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
            //         fetch(`${apiUrl}/users/@me`, {
            //             headers: new Headers({
            //                 'Authorization': `Bearer ${$accessToken}`,
            //             }),
            //         })
            //             .then(response => response.json())
            //             .then(json => {
            //                 console.log(json);
            //                 user.set(json);  // Build this from our own accounts service
            //             });
            //     } else {
            //         console.log(`Not done yet (ready state is ${xhr.readyState})`);
            //     }
            // }
            // xhr.open('POST', discordTokenURL);
            // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            // xhr.responseType = 'json';
            // xhr.send(params);
        } else {
            console.log(`Authentication state does not match state received from callback\n${previousAuthenticationState}!==${state}`);
        }
    }
    
    // window.opener.authenticate(service, code, state);
    // window.opener.name = 'Opener'
    // console.log(window.open('http://localhost:5000/login', window.opener.name));
    // window.close();

</script>

<style>
    /* this looks bad lol */
    div {
        background-image: url('assets/discord/longart.png');
    }
</style>
<!-- TODO: put some pretty animation here -->
<!-- either a really big one or a seamless repeatable one? -->

<div>
    <Debug.Auth authparams={{ service, code, state, previousState: previousAuthenticationState }}/>
</div>
